const ESCROW_ONBOARDING_STEP = 'escrowOnboardingStep';

const steps = [
  'members',
  'depositor',
  'beneficiary',
  'notification-settings',
  'activation-notifications',
  'asset-visibility',
  'storage-settings',
  'agreement-setup',
  'agreement-details',
  'summary',
] as const;

export type IOnboardingStep = (typeof steps)[number];

export const getEscrowOnboardingStep = (escrowId: string): IOnboardingStep | null => {
  const step = localStorage.getItem(`${ESCROW_ONBOARDING_STEP}-${escrowId}`) as IOnboardingStep;

  return steps.includes(step) ? step : null;
};

export const setEscrowOnboardingStep = (escrowId: string, step: IOnboardingStep) =>
  localStorage.setItem(`${ESCROW_ONBOARDING_STEP}-${escrowId}`, step);

export const resetEscrowOnboardingStep = (escrowId: string) =>
  localStorage.removeItem(`${ESCROW_ONBOARDING_STEP}-${escrowId}`);
